"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeValidationDisabledReason = exports.IncomeValidationStrategy = exports.STATED_INCOME_ENTRY_TYPES_RECORD = exports.STATED_ANNUAL_INCOME_PARTS = exports.IncomeEntryType = exports.IncomeType = exports.MIN_STATED_ANNUAL_INCOME_FOR_CRYPTO = exports.MIN_STATED_ANNUAL_INCOME = void 0;
exports.MIN_STATED_ANNUAL_INCOME = 20000;
exports.MIN_STATED_ANNUAL_INCOME_FOR_CRYPTO = 0;
/* @TranslateToPython */
var IncomeType;
(function (IncomeType) {
    IncomeType["UNKNOWN"] = "UNKNOWN";
    IncomeType["GROSS_MONTHLY"] = "GROSS_MONTHLY";
    IncomeType["NET_MONTHLY"] = "NET_MONTHLY";
    IncomeType["NET_ANNUAL"] = "NET_ANNUAL";
    IncomeType["GROSS_ANNUAL"] = "GROSS_ANNUAL";
})(IncomeType || (exports.IncomeType = IncomeType = {}));
/** @TranslateToPython @TranslateToEnum */
var IncomeEntryType;
(function (IncomeEntryType) {
    IncomeEntryType["STATED_INCOME"] = "STATED_INCOME";
    IncomeEntryType["STATED_ANNUAL_INCOME"] = "STATED_ANNUAL_INCOME";
    IncomeEntryType["STATED_RENTAL_INCOME"] = "STATED_RENTAL_INCOME";
    IncomeEntryType["STATED_ANNUAL_PERSONAL_INCOME"] = "STATED_ANNUAL_PERSONAL_INCOME";
    IncomeEntryType["STATED_ANNUAL_SPOUSE_INCOME"] = "STATED_ANNUAL_SPOUSE_INCOME";
    IncomeEntryType["STATED_ANNUAL_RENTAL_INCOME"] = "STATED_ANNUAL_RENTAL_INCOME";
    IncomeEntryType["STATED_ANNUAL_INVESTMENT_INCOME"] = "STATED_ANNUAL_INVESTMENT_INCOME";
    IncomeEntryType["STATED_ANNUAL_SOCIAL_SECURITY_INCOME"] = "STATED_ANNUAL_SOCIAL_SECURITY_INCOME";
    IncomeEntryType["STATED_ANNUAL_OTHER_INCOME"] = "STATED_ANNUAL_OTHER_INCOME";
    IncomeEntryType["STATED_TOTAL_SAVINGS"] = "STATED_TOTAL_SAVINGS";
})(IncomeEntryType || (exports.IncomeEntryType = IncomeEntryType = {}));
/** We shipped a frontend experiment variant that asks for these many things and we sum them up to get a STATED_INCOME for that experiment variant. */
/** STATED_ANNUAL_INCOME_PARTS is the list of income entry types that we ask in that experiment variant. */
/** @TranslateToPython */
exports.STATED_ANNUAL_INCOME_PARTS = [
    IncomeEntryType.STATED_ANNUAL_PERSONAL_INCOME,
    IncomeEntryType.STATED_ANNUAL_SPOUSE_INCOME,
    IncomeEntryType.STATED_ANNUAL_RENTAL_INCOME,
    IncomeEntryType.STATED_ANNUAL_INVESTMENT_INCOME,
    IncomeEntryType.STATED_ANNUAL_SOCIAL_SECURITY_INCOME,
    IncomeEntryType.STATED_ANNUAL_OTHER_INCOME,
];
/** Boolean to indicate whether the entry type is a stated income entry (to be used in underwriting). */
exports.STATED_INCOME_ENTRY_TYPES_RECORD = {
    [IncomeEntryType.STATED_INCOME]: true,
    [IncomeEntryType.STATED_ANNUAL_INCOME]: true,
    [IncomeEntryType.STATED_ANNUAL_PERSONAL_INCOME]: true,
    [IncomeEntryType.STATED_ANNUAL_SPOUSE_INCOME]: true,
    [IncomeEntryType.STATED_ANNUAL_RENTAL_INCOME]: true,
    [IncomeEntryType.STATED_ANNUAL_INVESTMENT_INCOME]: true,
    [IncomeEntryType.STATED_ANNUAL_SOCIAL_SECURITY_INCOME]: true,
    [IncomeEntryType.STATED_ANNUAL_OTHER_INCOME]: true,
    [IncomeEntryType.STATED_RENTAL_INCOME]: false,
    [IncomeEntryType.STATED_TOTAL_SAVINGS]: false,
};
/**
 * Please avoid enabling conflicting/redundant income validation strategies on any policy.
 * If you create a strategy that can be potentially conflicting, please add logic to prevent it in this policyValidation.py test: _validateIncomeValidationStrategiesNoConflict
 * @TranslateToPython */
var IncomeValidationStrategy;
(function (IncomeValidationStrategy) {
    // 1P: https://docs.google.com/document/d/1cSsuGmDRgrrOZRqgsLwUGUtuoITU2iivWI_bVI6hbBk
    IncomeValidationStrategy["ONLY_USE_IRS_IF_SUSPICIOUS_PLAID_INCOME_EXISTS"] = "ONLY_USE_IRS_IF_SUSPICIOUS_PLAID_INCOME_EXISTS";
    IncomeValidationStrategy["DISABLE_EXPERIAN_INCOME_DOCS_FOR_FICO_LOWER_THAN_750_APPLICATIONS"] = "DISABLE_EXPERIAN_INCOME_DOCS_FOR_FICO_LOWER_THAN_750_APPLICATIONS";
    IncomeValidationStrategy["ENABLE_STATED_LIQUID_ASSETS_IN_INCOME"] = "ENABLE_STATED_LIQUID_ASSETS_IN_INCOME";
    IncomeValidationStrategy["DISABLE_MANUAL_INCOME_DOC_UPLOAD"] = "DISABLE_MANUAL_INCOME_DOC_UPLOAD";
    IncomeValidationStrategy["DISABLE_TAX_RETURN_INCOME_DOC_UPLOAD"] = "DISABLE_TAX_RETURN_INCOME_DOC_UPLOAD";
    IncomeValidationStrategy["ENABLE_EXPERIAN_INCOME_INSIGHT_WITHOUT_EMPLOYMENT_STALENESS_GATE"] = "ENABLE_EXPERIAN_INCOME_INSIGHT_WITHOUT_EMPLOYMENT_STALENESS_GATE";
    // Used when origination asks for household income: the 1040 (tax-return) insight captures the
    // full filing-unit income (including spouse), whereas the W2 insight is individual wage income only.
    IncomeValidationStrategy["USE_INCOME_INSIGHT_1040_INSTEAD_OF_W2"] = "USE_INCOME_INSIGHT_1040_INSTEAD_OF_W2";
})(IncomeValidationStrategy || (exports.IncomeValidationStrategy = IncomeValidationStrategy = {}));
/* @TranslateToPython */
var IncomeValidationDisabledReason;
(function (IncomeValidationDisabledReason) {
    IncomeValidationDisabledReason["PlaidDerivedIncomeOver1M"] = "PlaidDerivedIncomeOver1M";
    IncomeValidationDisabledReason["PlaidIncomeAndDtiAndExperianAttributesAreRisky"] = "PlaidIncomeAndDtiAndExperianAttributesAreRisky";
    IncomeValidationDisabledReason["HighDelinquencyProbability"] = "HighDelinquencyProbability";
    IncomeValidationDisabledReason["DisabledByIncomeV2Whitelist"] = "DisabledByIncomeV2Whitelist";
    IncomeValidationDisabledReason["DisabledByEmploymentTypeRestriction"] = "DisabledByEmploymentTypeRestriction";
    IncomeValidationDisabledReason["DisabledForNonCreditKarmaUccProductFraudAttack"] = "DisabledForNonCreditKarmaUccProductFraudAttack";
    IncomeValidationDisabledReason["DisabledTaxReturnIncomeDocUpload"] = "DisabledTaxReturnIncomeDocUpload";
})(IncomeValidationDisabledReason || (exports.IncomeValidationDisabledReason = IncomeValidationDisabledReason = {}));
